/* hc-color-drop.js — countdowns + tap-to-open signup modal.
   The modal offers up to three subscriptions per signup: this color's list,
   the All Color Drops master list, and the main marketing list. Each checked
   option is one Klaviyo client-API subscription call; consent is recorded
   per list. Successful color-list signups are remembered in localStorage so
   that card shows its subscribed state on return visits. */
(function () {
  'use strict';
  var root = document.querySelector('[data-hccd]');
  if (!root) return;
  var KEY = root.getAttribute('data-klaviyo-key') || '';
  var LS = 'hccd-subscribed';

  function remembered() {
    try { return JSON.parse(localStorage.getItem(LS) || '[]'); } catch (e) { return []; }
  }
  function remember(list) {
    try {
      var r = remembered();
      if (r.indexOf(list) === -1) { r.push(list); localStorage.setItem(LS, JSON.stringify(r)); }
    } catch (e) { /* private mode */ }
  }

  // ---- countdowns ----
  var counts = Array.prototype.slice.call(root.querySelectorAll('[data-hccd-count]'));
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var now = Date.now();
    counts.forEach(function (el) {
      var t = Date.parse(el.getAttribute('data-hccd-count'));
      if (isNaN(t)) { el.style.display = 'none'; return; }
      var d = Math.max(0, t - now);
      el.innerHTML =
        '<b>' + pad(Math.floor(d / 86400000)) + '<small>days</small></b>' +
        '<b>' + pad(Math.floor(d % 86400000 / 3600000)) + '<small>hrs</small></b>' +
        '<b>' + pad(Math.floor(d % 3600000 / 60000)) + '<small>min</small></b>' +
        '<b>' + pad(Math.floor(d % 60000 / 1000)) + '<small>sec</small></b>';
    });
  }
  if (counts.length) { tick(); setInterval(tick, 1000); }

  // ---- subscribed card state ----
  function markCard(list) {
    var msg = root.querySelector('[data-hccd-cardmsg="' + list + '"]');
    var btn = root.querySelector('[data-hccd-open][data-list="' + list + '"]');
    if (msg) msg.textContent = 'On the list. We\u2019ll be brief.';
    if (btn) btn.style.display = 'none';
  }
  remembered().forEach(markCard);

  // ---- modal ----
  var modal = root.querySelector('[data-hccd-modal]');
  if (!modal) return;
  var mform = modal.querySelector('[data-hccd-mform]');
  var mtitle = modal.querySelector('[data-hccd-mtitle]');
  var optColorName = modal.querySelector('[data-hccd-optcolor]');
  var mmsg = modal.querySelector('.hccd-form__msg');
  var current = null; // { list, color }

  var mmedia = modal.querySelector('[data-hccd-media]');
  var mimg = modal.querySelector('[data-hccd-mimg]');
  function openModal(list, color, image) {
    current = { list: list, color: color };
    if (image && mimg) { mimg.src = image; mimg.alt = color; mmedia.hidden = false; }
    else if (mmedia) { mmedia.hidden = true; }
    mtitle.textContent = color + '. In your inbox.';
    optColorName.textContent = 'Just ' + color;
    mmsg.textContent = '';
    mform.reset();
    // pre-mark options already subscribed
    var subs = remembered();
    Array.prototype.slice.call(modal.querySelectorAll('[data-hccd-opt]')).forEach(function (cb) {
      var l = cb.getAttribute('data-hccd-opt') === 'color' ? list : cb.getAttribute('data-list');
      var done = subs.indexOf(l) > -1;
      cb.checked = done; // nothing pre-checked: CASL/GDPR require an affirmative act
      cb.disabled = done;
      cb.closest('.hccd-opt').classList.toggle('is-done', done);
    });
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var inp = mform.querySelector('input[name="email"]');
    setTimeout(function () { inp.focus(); }, 50);
  }
  function closeModal() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    current = null;
  }

  root.addEventListener('click', function (e) {
    var open = e.target.closest ? e.target.closest('[data-hccd-open]') : null;
    if (open) { openModal(open.getAttribute('data-list'), open.getAttribute('data-color'), open.getAttribute('data-image')); return; }
    if (e.target.closest && e.target.closest('[data-hccd-close]')) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  // ---- subscribe ----
  function subscribe(email, list, color) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KEY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Weight Drop page',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: (function () {
                    var p = { color_interest: color || '' };
                    if (color) p['Weight Drop: ' + color] = true; // segmentable per-color marker
                    return p;
                  })()
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      })
    }).then(function (r) {
      if (!(r.status === 202 || r.ok)) throw new Error('status ' + r.status);
      return list;
    });
  }

  mform.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!current) return;
    var email = (mform.querySelector('input[name="email"]').value || '').trim();
    if (!email || email.indexOf('@') === -1) { mmsg.textContent = 'Enter an email.'; return; }
    if (!KEY) { mmsg.textContent = 'Klaviyo public key missing in section settings.'; return; }

    var lists = [];
    Array.prototype.slice.call(modal.querySelectorAll('[data-hccd-opt]')).forEach(function (cb) {
      if (!cb.checked || cb.disabled) return;
      var l = cb.getAttribute('data-hccd-opt') === 'color' ? current.list : cb.getAttribute('data-list');
      if (l && lists.indexOf(l) === -1) lists.push(l);
    });
    if (!lists.length) { mmsg.textContent = 'Pick at least one.'; return; }

    var btn = mform.querySelector('.hccd-modal__submit');
    btn.disabled = true;
    mmsg.textContent = '';
    Promise.all(lists.map(function (l) { return subscribe(email, l, current.color); }))
      .then(function (done) {
        done.forEach(function (l) { remember(l); markCard(l); });
        mmsg.textContent = 'Done. We\u2019ll be brief.';
        setTimeout(closeModal, 900);
      })
      .catch(function () {
        mmsg.textContent = 'That didn\u2019t work. Try again.';
      })
      .then(function () { btn.disabled = false; });
  });
})();
